export const setMultiselectValuesFor = (selectedValues: string[], AllValues: Record<string, string>[]) => {
  if(selectedValues) return AllValues.filter((e) => selectedValues.includes(String(e.id)));
};

export const selectWithPlaceholderValue = (target: HTMLSelectElement) => target.value === target.options[0].value ? '' : target.value;

export const toggleInputType = (isTxt: boolean) => isTxt ? 'text' : 'password';
